import { render, staticRenderFns } from "./trials.vue?vue&type=template&id=385ed1e8&scoped=true&"
import script from "./trials.vue?vue&type=script&lang=js&"
export * from "./trials.vue?vue&type=script&lang=js&"
import style0 from "../pc.css?vue&type=style&index=0&id=385ed1e8&scoped=true&lang=css&"
import style1 from "../phone.css?vue&type=style&index=1&id=385ed1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385ed1e8",
  null
  
)

export default component.exports